/**
 * Abstand zum nächsten Earnings-Termin — die Zahl, auf der die Sperre beruht.
 *
 * Bewusst eine eigene, winzige Datei ohne Datenbankzugriff: Die Rechnung muss
 * geprüft sein, weil an ihr eine Kauf-Sperre hängt. Das Holen der Zeile liegt
 * daneben in `earnings-read.ts`, damit dieses Modul testbar bleibt.
 *
 * KALENDERTAGE, nicht Handelstage. `v5_earnings_cache` liefert ein Datum und
 * keinen Börsenkalender; eine Umrechnung wäre eine Schätzung, die genauer
 * aussieht, als sie ist. Der Sperr-Abstand ist entsprechend gesetzt.
 */

/**
 * Kalendertage von `heute` bis `datum`. Negativ, wenn der Termin vorbei ist.
 *
 * Beide Seiten werden auf Mitternacht UTC normiert. Ohne das entschiede die
 * Uhrzeit des Aufrufs über das Ergebnis: Um 23:00 wäre der Termin von morgen
 * „in 0 Tagen", um 01:00 „in 1 Tag" — die Sperre würde im Tagesverlauf
 * umspringen.
 */
export function kalendertageBis(datum: string, heute: string): number | null {
  const ziel = Date.parse(`${datum.slice(0, 10)}T00:00:00Z`);
  const jetzt = Date.parse(`${heute.slice(0, 10)}T00:00:00Z`);
  if (Number.isNaN(ziel) || Number.isNaN(jetzt)) return null;
  return Math.round((ziel - jetzt) / 86_400_000);
}
